import React, { useState , useEffect} from "react";
//import { withRouter, Link,Route } from "react-router-dom";
//import { useNavigate } from 'react-router-dom';
import { setUserDetail } from "../../redux/actions/appActions";
import Loader from "../../components/loaders/loader";
import { loginApi, multipartPostCall, sendTokenAPI, validateTokenAPI,updatePasswordAPI } from "../../services";
import { apiUrl, appTranslationsPath } from "../../services/urls";
import { applyTranslations, mergeSmartSetupTranslations } from "../../i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom"; // For navigation

import { useDispatch } from "react-redux";
import { decryptData, encryptData } from "../../AesEnc.js";
import axios from "axios";
import TextError from "../../components/ErrorText";
import {
  Button,
  Form,
  Modal,
  Container,
} from "react-bootstrap";
import { ErrorMessage, Field, Formik, Form as FForm } from "formik";

const Login = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [showPasswordFlag, setShowPassword] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [responseError, setResponseError] = useState("");
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[a-zA-Z\d!@#$%^&*()]{8,}$/;
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  useEffect(() => {
    localStorage.removeItem('persist:root');
    sessionStorage.removeItem("Admin_Authorization");
    const searchParams = new URLSearchParams(window.location.search);
    const queryParam = searchParams.get("activateaccount"); // Get the entire query string
    console.log(queryParam,"queryParam")
    if (queryParam == "1") {
      // const newUrl = `${window.location.pathname}activateaccount`;
      navigate("/activateaccount?email="+searchParams.get('email'))
      // window.location.replace(newUrl); // Redirect to the new URL
    }
  }, []);


  const handleSubmit = (e) => {
    // setLoading(true);
    e.preventDefault();

    const Authorization = "Basic " + btoa(email.trim() + ":" + password.trim());

    loginApi(Authorization)
      .then((res) => {
        console.log(res)
        if(res.data.userRoles[0].name != "APPADMIN" && res.data.userRoles[0].name != "Superuser"){
          swal({
            title: "Access Denied",
            //text: error.response.data.message,
            text: "You do not have the required access.",
            icon: "error",
            button: "Close",
          });
          return
        }
        let instance = axios.create();
        instance.defaults.headers.common["Authorization"] = Authorization;
        instance
          .get(apiUrl + "organisationUnits/" + res.data.organisationUnits[0].id)
          .then((orgres) => {
            if (orgres && orgres.data && orgres.data.path) {
              let orgheirarchypath = orgres.data.path;
              let orgunit = orgheirarchypath.split("/")[2];
              // https://tpttest.imonitorplus.com/service/api/37/dataStore/translations/vsHsKkQBDU5
              instance
                .get(apiUrl + "dataStore/translations/" + orgunit)
                .then((ress) => {
                  console.log(ress.data);
                  if (ress.data["TB"]) {
                    res.data["programuid"] = ress.data["TB"].programuid;
                    res.data["appname"] = ress.data["TB"].appname;
                    res.data["selectedlanguage"] = ress.data["TB"].selectedlanguage;
                  } else {
                    res.data["programuid"] = ress.data.programuid;
                    res.data["appname"] = ress.data.appname;
                    res.data["selectedlanguage"] = ress.data.selectedlanguage;
                    res.data["mfaFlag"] = ress.data.mfaFlag
                  }

                  const orgId = res.data.organisationUnits[0].id;

                  const finishLogin = () => {
                    res.data["orguid"] = orgId;
                    res.data["orgname"] = orgres.data.name;
                    sessionStorage.setItem("userData", JSON.stringify(res.data));
                    sessionStorage.setItem("Admin_Authorization", Authorization);
                    dispatch(setUserDetail(res.data));
                    setLoading(false);
                    onSuccess();
                  };

                  const loadSmartSetup = () => {
                    return instance
                      .get(apiUrl + "tracker/smartsetup/get/" + orgId)
                      .then((smartRes) => {
                        res.data.smartsetup = smartRes.data;
                        mergeSmartSetupTranslations(smartRes.data);
                      })
                      .catch((smartErr) => {
                        console.error("Failed to load smart setup", smartErr);
                      })
                      .then(() => finishLogin());
                  };

                  instance
                    .get(apiUrl + appTranslationsPath)
                    .then((transRes) => {
                      applyTranslations(transRes.data);
                    })
                    .catch((transErr) => {
                      console.error("Failed to load translations", transErr);
                    })
                    .then(() => loadSmartSetup());
                });
            }
          });
      })
      .catch((error) => {
        if (error.response) {
          swal({
            title: "Login Failed",
            //text: error.response.data.message,
            text: "Please check the credentials.",
            icon: "error",
            button: "Close",
          });
        } else {
          swal({
            title: "Login Failed",
            text: "Please check the credentials.",
            icon: "error",
            button: "Close",
          });
        }
        setLoading(false);
      });
  };

  const handleLogout = () => {
    //console.log(":inside logout");
    sessionStorage.removeItem("Admin_Authorization");
    //window.location.reload();
    // this.props.history.push("/Home");
  };

  function showPassword() {
    if (showPasswordFlag) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  }

  const resetCreds = () => {
    setEmail("");
    setPassword("");
  }

  const handleUserInput = ({ target }) => {
    let { name, value } = target;
    if (name === "email") {
      setEmail(value);
      // validateField('email',value);
    } else {
      setPassword(value);
      validateField('password',value);
    }
  };
  const validateField = (fieldName, value) => {
    let emailValid,
      passwordValid,
      fieldValidationErrors = {};
    //console.log(fieldName, value);
    switch (fieldName) {
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? "" : "Email is invalid";
        setEmailError(fieldValidationErrors.email);
        setIsEmailValid(emailValid);
        break;
      case "password":
        passwordValid = value.length >= 6;
        fieldValidationErrors.password = passwordValid
          ? ""
          : "Password is too short, atleast 6 character";
        setPasswordError(fieldValidationErrors.password);
        setIsPasswordValid(passwordValid);
        break;
      default:
        break;
    }
  };
  const errorClass = (error) => {
    return !error ? "" : "is-invalid";
  };

  const errorResp = responseError ? (
    <div
      className="alert alert-danger"
      dangerouslySetInnerHTML={{ __html: responseError }}
    ></div>
  ) : (
    ""
  );

  const [defaultChecked, setDefaultChecked] = useState(true);
  const [adminChecked, setAdminChecked] = useState(false);
  const handleDefaultLogin = (e) => {
    if (e.target.checked) {
      setDefaultChecked(true);
      setAdminChecked(false);
      setEmail();
      setPassword();
    } else {
      setEmail("");
      setPassword("");
      setDefaultChecked(false);
    }
  };
  const handleAdminDefaultLogin = (e) =>{
    if (e.target.checked) {
      setAdminChecked(true);
      setDefaultChecked(false)
      setEmail("");
      setPassword("");
    } else {
      setEmail("");
      setPassword("");
      setAdminChecked(false);
    }
  }

  // Forgot password functionality
  function openForgotPasswordPopup() {
  swal({
    title: "Forgot Password",
    text: "Please enter your username to reset your password",
    content: "input",
    buttons: ["Cancel", "Continue"],
    className: "my-custom-swal",
    icon: "info",
    closeOnClickOutside: false,
  }).then((username) => {
    if (username === null) {
      // User clicked Cancel, do nothing
      return;
    }
    
    if (username && username.trim()) {
      validateUsername(username.trim());
    } else {
      // Show error if Continue clicked without input
      swal({
        title: "Username Required",
        text: "Please enter your username to continue.",
        icon: "warning",
        className:"my-custom-swal",
        button: "OK",
      }).then(() => {
        openForgotPasswordPopup(); // Show the popup again
      });
    }
  });
}



// Step 1: Validate username and send token
function validateUsername(username) {
  const requestBody = {
    status: "1",
    username,
    userrole: "",
    userid: ""
  };

  setLoading(true);

  sendTokenAPI(requestBody)
    .then((res) => {
      setLoading(false);
      if (res.status === "success") {
        swal({
          title: "Token Required",
          text: "Please enter the verification token you received via your registered email.",
          icon: "warning",
          className:"my-custom-swal",
          button: "OK"
        }).then(() => openTokenVerificationModal(username));
      } else if(res.message === "service unavailable") {
        showInvalidUsernameAlert();
      }
      else {
        showMissingEmailAlert();
      }
    })
    .catch((err) => {
      setLoading(false);
      console.error("Error validating username:", err);
      showErrorAlert(err, "Failed to validate username.");
    });
}

// Step 2: Send token to email
function sendTokenToEmail(username) {
 const requestBody = {
    status: "1",
    username,
    userrole: "",
    userid: ""
  };

  setLoading(true);

  sendTokenAPI(requestBody)
    .then((res) => {
      setLoading(false);
      if (res.status === "success") {
        swal({
          title: "Token Sent!",
          text: "A verification token has been sent to your email address.",
          icon: "success",
          button: "Continue"
        }).then(() => openTokenVerificationModal(username));
      } else {
        showTokenFailureAlert();
      }
    })
    .catch((err) => {
      setLoading(false);
      showErrorAlert(err, "Failed to send token.");
    });
}

// Step 3: Token verification modal
function openTokenVerificationModal(username) {
swal({
  title: "Enter Verification Token",
  content: {
    element: "input",
    attributes: {
      placeholder: "Enter token here",
      type: "text",
    },
  },
  buttons: {
    cancel: "Cancel",
    resend: { text: "Resend", value: "resend" },
    verify: { text: "Verify", value: "verify" },
  },
  className:"my-custom-swal",
  closeOnClickOutside: false,
}).then((value) => {
    const tokenInput = document.querySelector('.swal-content input');
    const token = tokenInput?.value.trim();

    if (value === "resend") {
      sendTokenToEmail(username);
    } else if (value === "verify") {
      if (token) {
        verifyTokenAndShowPasswordModal(username, token);
      } else {
        swal({
          title: "Token Required",
          text: "Please enter the verification token.",
          icon: "warning",
          button: "OK"
        }).then(() => openTokenVerificationModal(username));
      }
    }
  });

}

// Step 4: Verify token and show password modal
function verifyTokenAndShowPasswordModal(username, token) {
  setLoading(true);

  validateTokenAPI({ username, token })
    .then((res) => {
      const response = decryptData(res);
      setLoading(false);

      if (response.status === "success") {
        swal({
          title: "Token Validated!",
          text: "Please set a new password.",
          icon: "success",
          className:"my-custom-swal",
          button: "Continue"
        }).then(() => openNewPasswordModal(username, token));
      } else {
        swal({
          title: "Invalid Token",
          text: "The token is invalid. Please try again.",
          icon: "error",
          className:"my-custom-swal",
          button: "Retry"
        }).then(() => openTokenVerificationModal(username));
      }
    })
    .catch((err) => {
      setLoading(false);
      showErrorAlert(err, "Token validation failed.");
    });
}

// Step 5: Show new password modal
function openNewPasswordModal(username, token) {

  // Exact SVG paths from Font Awesome Free Regular (far fa-eye / far fa-eye-slash)
  const eyeOpenSVG1 = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="18" height="18" fill="#888">
      <path d="M288 144a144 144 0 1 0 144 144A144 144 0 0 0 288 144zm0 240a96 96 0 1 1 96-96 96 96 0 0 1-96 96zm0-160a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm284.52 36.58C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 260.58a31.94 31.94 0 0 0 0 22.84C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-196.58a31.94 31.94 0 0 0 0-22.84zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"/>
    </svg>`;

  const eyeOffSVG1 = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="18" height="18" fill="#888">
      <path d="M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429 240.39 416 224 416 204a96 96 0 0 0-96-96 95.94 95.94 0 0 0-23.21 38.47zm-37.56 55.44L123.45 96.42C176.29 63.07 228.88 48 320 48c117.54 0 221.53 64.55 278.71 144.4a31.91 31.91 0 0 1 0 22.92c-16.75 27.73-42.21 57.3-74.09 82.43l-59.47-46.47C468 239.7 470 230 470 220c0-72.79-55-132.38-125.07-139.67a95.93 95.93 0 0 0-85.7 121.58zM320 464c-117.54 0-221.53-64.55-278.71-144.4a31.91 31.91 0 0 1 0-22.92c16.47-27.28 41.43-56.44 72.77-81.45l-43.77-34.2C27.77 209.73 3 240.49 3 256c0 1 .17 2 .21 2.94C57 376.52 164.06 448 320 448a372.34 372.34 0 0 0 74.19-7.67l-54-42.19A95.83 95.83 0 0 1 320 400a96 96 0 0 1-96-96 95.82 95.82 0 0 1 1.22-15.11l-50.77-39.7A163.32 163.32 0 0 0 172 268a148.23 148.23 0 0 0 148 148 147.52 147.52 0 0 0 62.22-13.89l-62.22-48.64z"/>
    </svg>`;

  const eyeOpenSVG = '<i class="fas fa-eye"></i>';
  const eyeOffSVG = '<i class="fas fa-eye-slash"></i>';

  const passwordForm = document.createElement('div');
  passwordForm.innerHTML = `
    <div style="text-align: left; margin-top: 15px;">

      <label style="font-weight: bold;">Username:</label>
      <input type="text" value="${username}" disabled
        style="width: 95%; margin-bottom: 15px; border: none; background-color: #f2f2f2;
               padding: 10px; font-size: 14px; box-sizing: border-box;" />

      <label style="font-weight: bold;">New Password:</label>
      <div style="position: relative; margin-bottom: 15px; width: 95%;">
        <input type="password" id="newPassword" placeholder="Enter new password"
          style="width: 100%; border: none; background-color: #f9f9f9;
                 padding: 10px 40px 10px 10px; font-size: 14px; box-sizing: border-box;" />
        <button type="button" id="toggleNewPassword"
          style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
                 background: none; border: none; cursor: pointer; padding: 0;
                 display: flex; align-items: center;">
          <span id="eyeIconNew"></span>
        </button>
      </div>

      <label style="font-weight: bold;">Confirm Password:</label>
      <div style="position: relative; margin-bottom: 5px; width: 95%;">
        <input type="password" id="confirmPassword" placeholder="Confirm new password"
          style="width: 100%; border: none; background-color: #f9f9f9;
                 padding: 10px 40px 10px 10px; font-size: 14px; box-sizing: border-box;" />
        <button type="button" id="toggleConfirmPassword"
          style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
                 background: none; border: none; cursor: pointer; padding: 0;
                 display: flex; align-items: center;">
          <span id="eyeIconConfirm"></span>
        </button>
      </div>

      <div style="font-size: 12px; color: #666; margin-top: 5px; margin-bottom: 10px;">
        Password must contain at least 8 characters, 1 lowercase, 1 uppercase, 1 number, and 1 symbol.
      </div>
    </div>
  `;

  // Set initial icons (hidden state = eyeOff)
  passwordForm.querySelector('#eyeIconNew').innerHTML = eyeOffSVG;
  passwordForm.querySelector('#eyeIconConfirm').innerHTML = eyeOffSVG;

  // Toggle New Password
  passwordForm.querySelector('#toggleNewPassword').addEventListener('click', function () {
    const input = passwordForm.querySelector('#newPassword');
    const icon = passwordForm.querySelector('#eyeIconNew');
    const isHidden = input.type === 'password';
    input.type = isHidden ? 'text' : 'password';
    icon.innerHTML = isHidden ? eyeOpenSVG : eyeOffSVG;
  });

  // Toggle Confirm Password
  passwordForm.querySelector('#toggleConfirmPassword').addEventListener('click', function () {
    const input = passwordForm.querySelector('#confirmPassword');
    const icon = passwordForm.querySelector('#eyeIconConfirm');
    const isHidden = input.type === 'password';
    input.type = isHidden ? 'text' : 'password';
    icon.innerHTML = isHidden ? eyeOpenSVG : eyeOffSVG;
  });

  swal({
    title: "Set New Password",
    content: passwordForm,
    buttons: {
      cancel: "Cancel",
      confirm: { text: "Update Password", value: "update" },
    },
    icon: "info",
    className:"my-custom-swal",
    closeOnClickOutside: false
  }).then((result) => {
    if (result === "update") {
      const newPassword = document.getElementById('newPassword').value.trim();
      const confirmPassword = document.getElementById('confirmPassword').value.trim();

      if (!newPassword || !confirmPassword) {
        return showSimpleAlert("Missing Information", "Please fill in both password fields.", "warning", () =>
          openNewPasswordModal(username, token));
      }

      if (newPassword !== confirmPassword) {
        return showSimpleAlert("Password Mismatch", "Passwords do not match.", "error", () =>
          openNewPasswordModal(username, token));
      }

      if (!passwordRegex.test(newPassword)) {
        return showSimpleAlert(
          "Invalid Password",
          "Password must contain at least 8 characters, including 1 lowercase, 1 uppercase, 1 number, and 1 special character.",
          "warning",
          () => openNewPasswordModal(username, token)
        );
      }

      updatePassword(username, newPassword, token);
    } else {
      swal.close();
    }
  });
}

// Step 6: Update password
function updatePassword(email, password, token) {
  setLoading(true);

  updatePasswordAPI({ email, password })
    .then(() => {
      setLoading(false);
      swal({
        title: "Password Updated!",
        text: "Your password has been successfully updated.",
        icon: "success",
        button: "Ok"
      }).then(() => {
        swal.close(); // Or redirect
      });
    })
    .catch((err) => {
      setLoading(false);
      swal({
        title: "Update Failed",
        text: err.response?.data?.message || "Failed to update password.",
        icon: "error",
        buttons: {
          retry: { text: "Try Again", value: "retry" },
          cancel: { text: "Cancel", value: null }
        }
      }).then((result) => {
        if (result === "retry") {
          verifyTokenAndShowPasswordModal(email, token);
        }
      });
    });
}

function showSimpleAlert(title, text, icon, callback) {
  swal({ title, text, icon, button: "OK" }).then(callback);
}

function showErrorAlert(err, fallbackMsg) {
  swal({
    title: "Error",
    text: err.response?.data?.message || fallbackMsg,
    icon: "error",
    button: "Try Again"
  }).then(() => openForgotPasswordPopup());
}

function showInvalidUsernameAlert() {
  swal({
    title: "Invalid Username",
    text: "The username you entered is not valid. Please check and try again.",
    icon: "error",
    className:"my-custom-swal",
    button: "Try Again"
  }).then(() => openForgotPasswordPopup());
}

function showMissingEmailAlert() {
  swal({
    title: "Email Not Found",
    text: "No email found with this username. Please check and try again.",
    icon: "error",
    button: "Try Again"
  }).then(() => openForgotPasswordPopup());
}

function showTokenFailureAlert() {
  swal({
    title: "Token Error",
    text: "Failed to send verification token. Please try again.",
    icon: "error",
    button: "Retry"
  }).then(() => openForgotPasswordPopup());
}



  function showPassword() {
    if (showPasswordFlag) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  }

  return (
    <div className="app bgLogin">
      <Loader isLoading={loading} />
      <div className="container-fluid mainContent">
        <div className="row w-100">
          <div className="col-lg-3"></div>
          <div className="col-lg-6 bg-greycolor logincenter">
            <div className="loginContainer w-100">
              <div className="row">
                <div className="col-lg-4 sideImage">
                  <div className="sideimagelogo">
                    <div className="logohome">
                      <img
                        src={require("../../assets/images/cdic-logo.png")}
                        alt="gallary"
                        style={{ width: "100%" }}
                        className="ml-2"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="card loginCard">
                    <div className="card-body">
                      <div className="text-center mb-4">
                        <h4 className="login-head">Login</h4>
                      </div>
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label className="color-white mb-0">User Name</label>
                          <div className="input-group">
                            {/* <span className="input-group-addon">
                              <i className="far fa-user-circle"></i>
                            </span> */}
                            <input
                              autoComplete="off"
                              type="text"
                              className={`form-control  ${errorClass(
                                emailError
                              )}`}
                              onChange={handleUserInput}
                              value={email}
                              name="email"
                              placeholder="Enter your username"
                            />
                            <em className="error invalid-feedback">
                              {emailError}
                            </em>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="color-white mb-0">Password</label>
                          <div className="input-group">
                            <input
                              autoComplete="off"
                              type={showPasswordFlag ? "text" : "password"} // Toggle input type
                              className={`form-control  ${errorClass(passwordError)}`}
                              onChange={handleUserInput}
                              value={password}
                              name="password"
                              placeholder="Enter your password"
                            />
                           
                            <span 
                              className="input-group-text visibility-icon-container" 
                              onClick={() => showPassword()}
                              style={{ cursor: "pointer" }}
                            >
                              <FontAwesomeIcon icon={showPasswordFlag ? faEye : faEyeSlash} />
                            </span>
                          </div>
                           <div className="error-feedback">{passwordError}</div>
                        </div>

                        <button
                          type="submit"
                          // disabled={!formValid}
                          className="btn btn-default loginBtn "
                        >
                          Login
                        </button>
                        <button
                          type="reset"
                          onClick={resetCreds}
                          className={password || email ? "btn mt-2 btn-default loginBtn" : "btn mt-2 btn-default loginBtn disabled"}
                        >
                          Reset
                        </button>
                      
                      </form>
                      <div className="color-white tx-12 registerMargin">
                        {/* Don't have an account? Create an Account */}
                      </div>
                       <div>
                        <p
                          className="forgotbtn"
                          onClick={() => openForgotPasswordPopup()}
                          type="button"
                        >
                          Forgot Password
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3"></div>
        </div>
      </div>

      {/*<footer className="footer">
        <p>Powered By</p>
        <img
          src={require("../../assets/images/durelogowhite.png")}
          alt="gallary"
          className="ml-2"
        />
      </footer>*/}
       <Modal show={showModal} onHide={handleClose} centered className="reset-password">
        <Modal.Header closeButton className="p-2">
          <Modal.Title className="h5">Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Formik
              initialValues={{
                email: "",
              }}
              //validationSchema={resetCreds}
              onSubmit={(values) => {
                if(!values?.email?.trim()){
                     swal({
                      title: "Alert",
                      text: "Please enter username",
                      icon: "warning",
                      button: "Close",
                    });
                    return;
                }
                //dispatch(setLoader(true));
                var bodyFormData = new FormData();
                bodyFormData.append("username", values.email);
                multipartPostCall("account/recovery", bodyFormData)
                  .then((res) => {
                    // console.log(res)
                    //dispatch(setLoader(false));
                    setShowModal(false);
                    swal({
                      title: "Done",
                      text: res.data.message,
                      icon: "success",
                      button: "Close",
                    });
                  })
                  .catch((err) => {
                    //dispatch(setLoader(false));
                    if (err.response) {
                      swal({
                        title: "Fail",
                        text: err.response.data.message,
                        icon: "error",
                        button: "Close",
                      });
                    } else {
                      swal({
                        title: "Fail",
                        text: "Fail to update",
                        icon: "error",
                        button: "Close",
                      });
                    }
                  });
              }}
            >
              {({ errors, touched }) => (
                <FForm>
                  <Form.Group controlId="formBasicEmail">
                    <Field name="email">
                      {({ field, meta }) => {
                        return (
                          <>
                            <Form.Label className="label">Username</Form.Label>
                            <div className="formgroup">
                              <span className="formInput">
                                <input
                                  type="text"
                                  className="form-control"
                                  {...field}
                                />
                              </span>
                            </div>
                          </>
                        );
                      }}
                    </Field>
                    <ErrorMessage component={TextError} name="email" />
                  </Form.Group>
                  <Button variant="primary" type="submit">
                    Reset
                  </Button>
                </FForm>
              )}
            </Formik>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Login;
// export default withRouter(Login);
